import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import { StyledLink } from "pro-features/styled components/StyledLink/src/StyledLink";

export const StyledTooltipLink = styled(StyledLink)`
    display: flex;
    align-items: center;
    column-gap: 8px;
    color: currentcolor;
    user-select: none;

    & ${SWReactIcons} svg path {
        fill: currentcolor;
    }
`;
